import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import type { PageQuery, PagedResult } from '@domain/models/paged-result.model';
import type { StoreSettlement } from '@domain/models/store.model';
import { SettlementRepository } from '@domain/repositories/settlement.repository';

import type { ApiPagedResponse } from '@data/dto/api.dto';
import type { StoreSettlementDto } from '@data/dto/store.dto';
import { mapPagedSettlements, storeQueryParams } from '@data/mappers/store.mapper';

@Injectable()
export class SettlementApiRepository extends SettlementRepository {
  private readonly http = inject(HttpClient);
  private readonly path = 'api/order-settlements';

  list(query: PageQuery): Observable<PagedResult<StoreSettlement>> {
    const params = new HttpParams({
      fromObject: storeQueryParams(query) as Record<string, string | number>,
    });

    return this.http
      .get<ApiPagedResponse<StoreSettlementDto>>(this.path, { params })
      .pipe(map(mapPagedSettlements));
  }
}
